"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[875],{

/***/ 9875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(8368);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 11 modules
var menu = __webpack_require__(6626);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(9065);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Navbar/consts.js
var NAV_DEF = new Map([
    {
        name: "Employers",
        sections: [
            {
                name: "Why Choose Evry",
                description: "We deliver health insurance that helps ensure the people that we serve live healthier and happier lives.",
                link: "/why-choose-evry",
                icon: "/briefcase.svg",
                target: "_self"
            },
            {
                name: "How We Do It",
                description: "Built for the modern business and the mobile workforce.",
                link: "/how-we-do-it",
                icon: "/two-people.svg",
                target: "_self"
            },
            {
                name: "How We Compare",
                description: "We created the health insurance that we've always wanted to have.",
                link: "/how-we-compare",
                icon: "/compare-icon.svg",
                target: "_self"
            }, 
        ],
        related: {
            type: "image",
            media: "/work-colleagues-discussing-business-together.png",
            title: "Meet Your New Team",
            description: "You’ll be a member too! See why Evry really is a different brand of health insurance.",
            link: "/meet-your-new-team",
            button: "Learn More"
        }
    },
    {
        name: "Members",
        sections: [
            {
                name: "Find a Provider",
                description: "Build a great relationship with a local physician.",
                link: "https://providers.evryhealth.com/",
                icon: "/folders-icon.svg",
                target: "_blank"
            },
            {
                name: "Look Up Prescriptions",
                description: "Easily find covered medications.",
                link: "https://prime.adaptiverx.com/webSearch/index?key=cnhmbGV4LnBsYW4uUGxhblBkZlR5cGUtODA5",
                icon: "/briefcase.svg",
                target: "_blank"
            },
            {
                name: "Find a Pharmacy",
                description: "Find a pharmacy near you.",
                link: "https://web.primetherapeutics.com/member/find-a-pharmacy",
                icon: "/pharmacy.svg",
                target: "_blank"
            },
            {
                name: "Meet Your New Team",
                description: "With Evry, you'll be paired with your own team of nurses, nutritionists, and doctors who work for you.",
                link: "/meet-your-new-team",
                icon: "/stethescope.svg",
                target: "_self"
            },
            {
                name: "Download the Evry mobile app",
                description: "All the features you expect.",
                link: "/mobileapp",
                icon: "/download-icon-blue.svg",
                target: "_self"
            },
            {
                name: "Virtual Care",
                description: "Talk to a board-certified physician 24/7 for $0. Available on-demand by phone and video.",
                link: "/virtual-care",
                icon: "/mobile-phone-icon.svg",
                target: "_self"
            },
            {
                name: "Forms and Notices",
                description: "Download any forms you need.",
                link: "/forms?type=Members",
                icon: "/search-shield-icon.svg",
                target: "_self"
            }, 
        ],
        related: {
            type: "image",
            media: "/work-colleagues-discussing-business-together-during-work.png",
            title: "Questions?",
            description: "Our team is here to answer any questions you may have about your plan.",
            link: "/contact-us",
            button: "Contact Us"
        }
    },
    {
        name: "Providers",
        sections: [
            {
                name: "Prior Authorization",
                description: "See which procedures need prior authorization.",
                link: "/prior-authorization",
                icon: "/key-icon.svg",
                target: "_self"
            },
            {
                name: "Notifications and Admissions",
                description: "Inpatient admission notification helps to get your claims paid correctly and on time.",
                link: "/admission-notification",
                icon: "/notification-icon.svg",
                target: "_self"
            },
            {
                name: "Request to Join the Evry Network",
                description: "Faster payments. No games.",
                link: "/join-the-evry-network",
                icon: "/radio-checkmark.svg",
                target: "_self"
            },
            {
                name: "Retrospective Reviews",
                description: "Determining coverage after treatment has been given.",
                link: "/retrospective-reviews",
                icon: "/pages-icon.svg",
                target: "_self"
            },
            {
                name: "Clinical Practice Guidelines",
                description: "Evidence-based clinical practice guidelines and resources.",
                link: "/clinical-practice-guidelines",
                icon: "/pages-icon.svg",
                target: "_self"
            },
            {
                name: "Forms and Notices",
                description: "Download any forms you need.",
                link: "/forms?type=Providers",
                icon: "/search-shield-icon.svg",
                target: "_self"
            }, 
        ],
        related: {
            type: "image",
            media: "/lady-on-laptop-video-calling.png",
            title: "Virtual Care",
            description: "Our virtual care program will make your job easier too.",
            link: "/contact-us",
            button: "Contact Us"
        }
    },
    {
        name: "About",
        sections: [
            {
                name: "Our Story",
                description: "We're on a mission. A mission to build the health insurance company we've always wanted for ourselves.",
                link: "/our-story",
                icon: "/pages-icon.svg",
                target: "_self"
            },
            {
                name: "Careers",
                description: "We're making health insurance work again. Join us.",
                link: "/careers",
                icon: "/person-plus.svg",
                target: "_self"
            },
            {
                name: "News",
                description: "In the news.",
                link: "/news",
                icon: "/news.svg",
                target: "_self"
            }, 
        ],
        related: {
            type: "image",
            media: "/people-having-a-meeting.png",
            title: "Get in Touch",
            description: "We're here to answer any questions you have about our revolutionary health insurance plans.",
            link: "/contact-us",
            button: "Contact Us"
        }
    }, 
].map(function(x) {
    return [
        x.name,
        x
    ];
}));

;// CONCATENATED MODULE: ./hooks/usePrevious.js

var usePrevious = function(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
};

;// CONCATENATED MODULE: ./hooks/useChanged.js


var useChanged = function(val, fn) {
    var prevVal = usePrevious(val);
    (0,react.useEffect)(function() {
        if (prevVal !== val) fn(val, prevVal);
    }, [
        val,
        prevVal,
        fn
    ]);
};

;// CONCATENATED MODULE: ./components/Navbar/MobileNav.js






var MobileNav = function(param) {
    var open = param.open;
    (0,react.useEffect)(function() {
        document.body.style.overflow = open ? "hidden" : "auto";
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Panel */.p.Panel, {
        className: "overflow-auto",
        style: {
            maxHeight: "calc(90vh - 6rem)"
        },
        children: [
            (0,_to_consumable_array/* default */.Z)(NAV_DEF.values()).map(function(subnav, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(disclosure/* Disclosure */.p, {
                    as: "div",
                    className: "grid text-white px-4 pb-4 pt-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                            as: "h2",
                            className: "text-xl font-medium text-blue-light font-[sans-serif]",
                            children: subnav.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Panel */.p.Panel, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-2 md:col-span-1 px-4 md:px-16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: subnav === null || subnav === void 0 ? void 0 : subnav.sections.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex py-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        type: "image/svg+xml",
                                                        data: "briefcase.svg",
                                                        className: "h-8 w-auto"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "px-8 inline-block",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: item.link,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "inline-block",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "inline-block text-xl text-blue-light font-[sans-serif]",
                                                                        children: item.name
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: item.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.name);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-2 md:col-span-1 px-4 md:px-16 font-[sans-serif]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-xl font-medium text-blue-light",
                                            children: "Related Resource"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex py-4 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pr-8 inline-block",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "#",
                                                            className: "inline-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "inline-block text-xl text-blue-light",
                                                                children: subnav.related.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: subnav.related.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: subnav.related.link,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "px-4 py-2 w-200 text-sm bg-transparent text-blue-light border-2 border-blue-light inline-block text-center mt-4",
                                                        children: "Learn More"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, subnav.name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/contact-us",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "text-xl font-medium text-blue-light pl-4 pb-4 font-[sans-serif]",
                    children: "Contact"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FontDownloadOutlined.js
var FontDownloadOutlined = __webpack_require__(3915);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 66 modules
var Tooltip = __webpack_require__(1851);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.js
/* This example requires Tailwind CSS v2.0+ */ 










var NAV_DEF_ARR = (0,_to_consumable_array/* default */.Z)(NAV_DEF.values());
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Navbar = function() {
    var applyReadingStyles = function applyReadingStyles() {
        document.body.style.fontFamily = "'Open Dyslexic', system-ui, sans-serif";
        document.body.style.letterSpacing = "0.35ch";
        document.body.style.wordSpacing = "1.225ch";
        document.body.style.fontVariantLigatures = "none";
        document.body.style.fontWeight = "600";
        document.body.style.fontSize = "105%";
    };
    var removeReadingStyles = function removeReadingStyles() {
        document.body.style.fontFamily = "";
        document.body.style.letterSpacing = "";
        document.body.style.wordSpacing = "";
        document.body.style.fontVariantLigatures = "";
        document.body.style.fontWeight = "";
        document.body.style.fontSize = "";
    };
    var ref = (0,react.useState)(), subNavIndex = ref[0], setSubNavIndex = ref[1];
    var ref1 = (0,react.useState)(0), navHeight = ref1[0], setNavHeight = ref1[1];
    var elRef = (0,react.useRef)([]);
    var animate = (0,react.useCallback)(function(newValue, oldValue) {
        if (oldValue === undefined) {
            var newEl = elRef.current[newValue];
            var cl = newEl.classList;
            cl.remove("md:-translate-x-full", "md:transition-all");
            cl.add("md:translate-x-full");
            cl.add("md:transition-all");
            cl.remove("md:translate-x-full", "md:opacity-0");
            setNavHeight(newEl.clientHeight);
        } else if (newValue === undefined) {
            var oldEl = elRef.current[oldValue];
            oldEl === null || oldEl === void 0 ? void 0 : oldEl.classList.remove("md:translate-x-0");
            oldEl === null || oldEl === void 0 ? void 0 : oldEl.classList.add("md:translate-x-full", "md:transition-all", "md:opacity-0");
            setNavHeight(0);
        } else {
            var newEl1 = elRef.current[newValue];
            var oldEl1 = elRef.current[oldValue];
            var ncl = newEl1.classList;
            var ocl = oldEl1.classList;
            ocl.remove("md:-translate-x-full", "md:translate-x-full", "md:transition-all");
            if (oldValue > newValue) {
                ncl.remove("md:translate-x-full", "md:transition-all");
                ncl.add("md:-translate-x-full");
                ocl.add("md:translate-x-full", "md:transition-all", "md:opacity-0");
                ncl.add("md:transition-all");
                ncl.remove("md:-translate-x-full", "md:opacity-0");
                setNavHeight(newEl1.clientHeight);
            } else {
                ncl.remove("md:-translate-x-full", "md:transition-all");
                ncl.add("md:translate-x-full");
                ocl.add("md:-translate-x-full", "md:transition-all", "md:opacity-0");
                ncl.add("md:transition-all");
                ncl.remove("md:translate-x-full", "md:opacity-0");
                setNavHeight(newEl1.clientHeight);
            }
        }
    }, []);
    useChanged(subNavIndex, animate);
    var ref2 = (0,react.useState)(false), readingFriendlyMode = ref2[0], setReadingFriendlyMode = ref2[1];
    var isBrowser = "object" !== "undefined";
    var isReadingFriendlyMode = isBrowser && window.localStorage.getItem("readingFriendlyMode") === "true";
    (0,react.useEffect)(function() {
        if (isReadingFriendlyMode && isBrowser) {
            document.body.classList.add("reading-friendly-mode");
        }
        setReadingFriendlyMode(isReadingFriendlyMode);
    }, []);
    var toggleReadingFriendlyMode = function() {
        if (readingFriendlyMode) {
            window.localStorage.setItem("readingFriendlyMode", false);
            removeReadingStyles();
            setReadingFriendlyMode(false);
        } else {
            window.localStorage.setItem("readingFriendlyMode", true);
            applyReadingStyles();
            setReadingFriendlyMode(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        as: "nav",
        className: "fixed top-0 left-0 z-50 w-full bg-blue-dark h-92px",
        onMouseLeave: function() {
            return setSubNavIndex();
        },
        children: function(param) {
            var open = param.open;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto px-2 sm:px-6 lg:px-16 font-[sans-serif]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex items-center justify-between h-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute inset-y-0 left-0 flex items-center sm:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                        className: "inline-flex items-center justify-center p-2 text-white rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Open main menu"
                                            }),
                                            open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                className: "block w-6 h-6",
                                                "aria-hidden": "true"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                                className: "block w-6 h-6",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-center flex-1 sm:items-stretch sm:justify-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center flex-shrink-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "hidden w-auto h-8 cursor-pointer xl:block",
                                                    src: "EvryHealth_Logo_RGB_COLOR_WHITE_TEXT.svg",
                                                    alt: "Evry Health Logo"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden sm:block sm:ml-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-4",
                                                children: [
                                                    (0,_to_consumable_array/* default */.Z)(NAV_DEF.values()).map(function(item, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            onMouseOver: function() {
                                                                return setSubNavIndex(i);
                                                            },
                                                            className: "text-white hover:text-white-light px-3 py-2 rounded-md cursor-pointer uppercase",
                                                            "aria-current": item.current ? "page" : undefined,
                                                            children: item.name
                                                        }, item.name);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/contact-us",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "px-3 py-2 text-white uppercase rounded-md cursor-pointer hover:text-white-light",
                                                            children: "Contact"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-0 min-[1460px]:flex-row min-[1460px]:gap-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "tel:1-855-579-3879",
                                                    className: "hidden cursor-pointer min-[990px]:block text-blue-light hover:text-white-light hover:underline",
                                                    children: "1-855-579-3879"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:support@evryhealth.com",
                                                    className: "hidden pr-4 text-blue-light nav2:inline hover:text-white-light hover:underline",
                                                    children: "support@evryhealth.com"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                                            as: "div",
                                            className: "relative ml-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://portal.evryhealth.com/sign-in",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "px-10 py-2 text-sm text-white rounded-none shadow-sm bg-blue hover:bg-white-light hover:text-blue",
                                                    children: "Login"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    fontSize: "16px"
                                                },
                                                children: "Reading friendly mode"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                                                as: "div",
                                                className: "relative ml-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: toggleReadingFriendlyMode,
                                                    type: "button",
                                                    className: "px-3 py-2 text-sm text-white rounded-none shadow-s ".concat(readingFriendlyMode ? "bg-white-light hover:bg-blue !text-blue hover:!text-white-light" : "bg-blue hover:bg-white-light hover:text-blue", " "),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FontDownloadOutlined/* default */.Z, {})
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:overflow-clip md:block md:relative md:transition-all",
                        style: {
                            height: "".concat(navHeight, "px")
                        },
                        children: (0,_to_consumable_array/* default */.Z)(NAV_DEF.values()).map(function(subnav, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                ref: function(el) {
                                    return elRef.current[i] = el;
                                },
                                className: "grid grid-cols-2 text-white md:p-16 md:w-full md:absolute md:translate-x-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-2 px-4 md:col-span-1 md:px-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-xl font-bold text-blue-light font-[sans-serif] pb-6",
                                                children: subnav.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: subnav === null || subnav === void 0 ? void 0 : subnav.sections.map(function(item) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex py-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("object", {
                                                                className: "w-auto h-4 mt-2 ml-2",
                                                                type: "image/svg+xml",
                                                                data: item.icon
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inline-block px-8",
                                                                children: [
                                                                    item.target === "_blank" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: item.link,
                                                                        target: item.target,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "inline-block",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                className: "inline-block text-xl hover:underline hover:text-white-light text-blue-light font-[sans-serif] cursor-pointer",
                                                                                children: item.name
                                                                            })
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: item.link,
                                                                        target: item.target,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            onClick: function() {
                                                                                return setSubNavIndex();
                                                                            },
                                                                            className: "inline-block",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                className: "inline-block text-xl hover:underline hover:text-white-light text-blue-light font-[sans-serif] cursor-pointer",
                                                                                children: item.name
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: item.description
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.name);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-2 px-4 md:col-span-1 md:px-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-xl font-bold text-blue-light font-[sans-serif] uppercase",
                                                children: "Related Resource"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "mt-6",
                                                src: subnav.related.media,
                                                alt: subnav.related.media
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex py-4 mt-10 max-w-475",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inline-block pr-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "#",
                                                                className: "inline-block",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "inline-block text-xl text-blue-light font-[sans-serif]",
                                                                    children: subnav.related.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: subnav.related.description
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: subnav.related.link,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "inline-block py-2 mt-8 text-sm text-center bg-transparent border-2 w-150 text-blue-light hover:bg-blue-light hover:text-white-light border-blue-light",
                                                                children: subnav.related.button
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, subnav.name);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                        open: open
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./components/Footer/Footer.js




/* This example requires Tailwind CSS v2.0+ */ var navigation = {
    employers: [
        {
            name: "Why Choose Evry",
            href: "/why-choose-evry"
        },
        {
            name: "How We Do It",
            href: "/how-we-do-it"
        },
        {
            name: "How We Compare",
            href: "/how-we-compare"
        }, 
    ],
    memberResources: [
        {
            name: "Provider Directory",
            href: "https://providers.evryhealth.com/"
        },
        {
            name: "Meet Your New Care Team",
            href: "meet-your-new-team"
        },
        {
            name: "Virtual Care",
            href: "/virtual-care"
        },
        {
            name: "Join the Evry Network",
            href: "/join-the-evry-network"
        }, 
    ],
    about: [
        {
            name: "Our Story",
            href: "/our-story"
        },
        {
            name: "Careers",
            href: "/careers"
        },
        {
            name: "Contact Us",
            href: "/contact-us"
        },
        {
            name: "News",
            href: "/news"
        }, 
    ],
    providerResources: [
        {
            name: "Forms",
            href: "/forms"
        },
        {
            name: "Prior Authorization",
            href: "/prior-authorization"
        },
        {
            name: "Admission Notification",
            href: "/admission-notification"
        },
        {
            name: "Clinical Practice Guidelines",
            href: "/clinical-practice-guidelines"
        }, 
    ],
    finePrint: [
        {
            name: "Terms ",
            href: "/terms"
        },
        {
            name: "Privacy ",
            href: "/privacy-policy"
        },
        {
            name: "FWA ",
            href: "/fwa"
        },
        {
            name: " Non-Discrimination Policy ",
            href: "/non-discrimination-policy"
        },
        {
            name: "Price Transparency",
            href: "https://github.com/evryhealth/price-transparency"
        }, 
    ],
    social: [
        {
            name: "Facebook",
            href: "#",
            icon: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    fill: "currentColor",
                    viewBox: "0 0 24 24"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
                        clipRule: "evenodd"
                    })
                }));
            }
        },
        {
            name: "Instagram",
            href: "#",
            icon: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    fill: "currentColor",
                    viewBox: "0 0 24 24"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
                        clipRule: "evenodd"
                    })
                }));
            }
        },
        {
            name: "LinkedIn",
            href: "#",
            icon: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    fill: "currentColor",
                    viewBox: "0 0 24 24"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                    })
                }));
            }
        },
        {
            name: "Twitter",
            href: "#",
            icon: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    fill: "currentColor",
                    viewBox: "0 0 24 24"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                    })
                }));
            }
        }, 
    ]
};
function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "text-white bg-blue",
        "aria-labelledby": "footer-heading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "footer-heading",
                className: "sr-only",
                children: "Footer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-full px-4 py-12 mx-auto sm:px-6 lg:py-16 lg:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:grid md:grid-cols-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 mx-auto mb-10 md:col-span-4 md:mb-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "cursor-pointer grayscale",
                                        src: "EvryHealth_Logo_RGB_COLOR_WHITE_TEXT.svg",
                                        alt: "Evry Health Logo",
                                        width: 300
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-1 md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold tracking-wider uppercase font-[sans-serif]",
                                        children: "Employers"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-4 space-y-2",
                                        children: navigation.employers.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        href: item.href,
                                                        className: "cursor-pointer text-light hover:underline hover:text-white-light",
                                                        children: item.name
                                                    })
                                                })
                                            }, item.name);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold tracking-wider uppercase mt-14 md:mt-14 font-[sans-serif]",
                                        children: "Provider Resources"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-4 space-y-2",
                                        children: navigation.providerResources.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "cursor-pointer hover:underline hover:text-white-light",
                                                        children: item.name
                                                    })
                                                })
                                            }, item.name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-1 mt-14 md:col-span-2 md:mt-0 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold tracking-wider uppercase font-[sans-serif]",
                                        children: "Member"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-4 space-y-2",
                                        children: navigation.memberResources.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "cursor-pointer hover:underline hover:text-white-light",
                                                        children: item.name
                                                    })
                                                })
                                            }, item.name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-1 mt-14 md:col-span-2 md:mt-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold tracking-wider uppercase font-[sans-serif]",
                                        children: "About"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-4 space-y-2",
                                        children: navigation.about.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "cursor-pointer hover:underline hover:text-white-light",
                                                        children: item.name
                                                    })
                                                })
                                            }, item.name);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold tracking-wider uppercase font-[sans-serif] mt-14 md:mt-20",
                                        children: "Fine Print"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-4 space-y-2",
                                        children: navigation.finePrint.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "cursor-pointer hover:underline hover:text-white-light",
                                                        children: item.name
                                                    })
                                                })
                                            }, item.name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 mx-auto mt-16 md:col-span-2 md:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "w-[175px] h-[165px] ml-[-12px]",
                                    src: "URAC-Accredited-white.png",
                                    alt: "URAC Accredited Logo"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-[100%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "max-w-2xl mt-8 text-xs text-center",
                            children: "\xa9 2025 Evry Healthcare Inc. All rights reserved. Evry Health \xae is a registered trademark of Evry Healthcare Inc. Evry Health Insurance Company of Texas (NAIC# 17135) is a subsidiary of Evry Healthcare, a Globe Life Company."
                        })
                    })
                ]
            })
        ]
    });
}
;
/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {});

;// CONCATENATED MODULE: ./layout/Layout.js
// import MetaInfo from "../components/MetaInfo/MetaInfo";



var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-screen grid grid-rows-[max-content,1fr,max-content] pt-92px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Navbar, {}),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
            ]
        })
    });
};
/* harmony default export */ var layout_Layout = (Layout);


/***/ })

}]);